module.exports = __webpack_public_path__ + "static/media/EditIcon.5fd931c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinProfile/EditIcon.svg
// module id = 355
// module chunks = 0